module.exports = __webpack_public_path__ + "static/4x_hr_onboarding_1-224fbfb2aaa0d849cec5b2f72b919811.png";